import gtmService from '../../../../../utils/gtm';
import { UniqueIdentifier } from '../../../../../types';
import { PricingProducts } from '../../../store/features/products/types';
import { getPriceAsNumber } from '../getPriceAsNumber';

export function pushAddToCartForGTM(
  pricingProducts: PricingProducts,
  productIds: UniqueIdentifier[],
  quantity: number,
) {
  const products = [
    ...pricingProducts.productTypesWithProducts,
    ...pricingProducts.optionalProductTypesWithProducts,
  ].flatMap(({ products: productList }) => productList);
  const productsForGTM = productIds.flatMap((productId) => {
    const product = products.find(({ id }) => id === productId);
    const price = getPriceAsNumber(product?.price);

    if (!product || price === null) {
      return [];
    }

    return [
      {
        name: product.name,
        brand: product.name,
        id: product.id,
        price,
        quantity,
      },
    ];
  });

  gtmService.pushAddToCart(pricingProducts.currency, productsForGTM);
}
